import styled, { css } from "styled-components";

export const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

export const SectionTitle = styled.h2`
  font-size: 20px;
  font-weight: 700;
  color: var(--fixit);
  margin-bottom: 8px;
  margin-top: 0;
  border-bottom: 1px solid var(--light-gray);
  padding-bottom: 8px;
`;

export const InputGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const Row = styled.div`
  display: flex;
  gap: 16px;
  width: 100%;

  @media (max-width: 768px) {
    flex-direction: column;
    gap: 16px;
  }
`;

export const FlexInput = styled.div<{ flex?: number }>`
  flex: ${({ flex }) => flex || 1};
  display: flex;
  flex-direction: column;
`;

export const Footer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  margin-top: 0;
  padding-top: 24px;
  border-top: 1px solid var(--light-gray);

  @media (max-width: 600px) {
    flex-direction: column-reverse;
    gap: 16px;
    
    button {
      width: 100%;
    }
  }
`;

